import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sarah M.",
    role: "Small Business Owner, Phoenix",
    text: "Mom & Pop saved us $4,200/year on our commercial package. Their broker compared 12 carriers and found coverage we didn't even know we needed. Incredible service.",
    rating: 5,
  },
  {
    name: "David & Lisa K.",
    role: "Homeowners, Scottsdale",
    text: "After our monsoon claim, they guided us through every step. We switched from a national carrier and got better coverage for less. They really know Arizona.",
    rating: 5,
  },
  {
    name: "Mark R.",
    role: "Fleet Manager, Mesa",
    text: "Managing insurance for 35 vehicles used to be a nightmare. Mom & Pop consolidated everything under one policy and cut our premium by 22%. Game changer.",
    rating: 5,
  },
  {
    name: "Jennifer T.",
    role: "HR Director, Chandler",
    text: "They helped us set up group benefits that actually attract talent. Our employees love the plan options, and we're spending less than before. Win-win.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-surface-alt">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Real stories from Arizona businesses and families who switched to independent insurance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-surface rounded-2xl p-6 md:p-8 shadow-card"
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-primary text-primary"
                  />
                ))}
              </div>
              <blockquote className="text-foreground leading-relaxed mb-5">
                "{t.text}"
              </blockquote>
              <div>
                <p className="font-semibold text-sm">{t.name}</p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-primary text-primary" />
              ))}
            </div>
            <span>4.9/5 average rating from 200+ clients</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
